import { create } from "zustand";
import type {
    CharacterSheetResponse,
    EquipmentResponse,
    InventoryResponse,
    RunDetailResponse,
    StatSheetResponse,
} from "@/api/types";

/**
 * 현재 활성 런의 통합 캐시. 씬 전환 시 같은 데이터를 다시 안 부르도록 유지.
 * 서버가 진실 — 액션 후 응답으로 매번 덮어씀 (optimistic update 는 ConsumableService 정도만 한정 사용).
 */

interface RunState {
    runId: string | null;
    run: RunDetailResponse | null;
    stats: StatSheetResponse | null;
    inventory: InventoryResponse | null;
    equipment: EquipmentResponse | null;
    lastLoadedAt: number | null;
}

interface RunActions {
    setActive: (runId: string) => void;
    setSheet: (bundle: CharacterSheetResponse) => void;
    setRun: (run: RunDetailResponse) => void;
    setStats: (stats: StatSheetResponse) => void;
    setInventory: (inv: InventoryResponse) => void;
    setEquipment: (eq: EquipmentResponse) => void;
    clear: () => void;
}

export const useRun = create<RunState & RunActions>((set) => ({
    runId: null,
    run: null,
    stats: null,
    inventory: null,
    equipment: null,
    lastLoadedAt: null,

    setActive: (runId) => set({ runId }),

    setSheet: (bundle) => set({
        runId: bundle.run.id,
        run: bundle.run,
        stats: bundle.stats,
        inventory: bundle.inventory,
        equipment: bundle.equipment,
        lastLoadedAt: Date.now(),
    }),

    setRun: (run) => set({ run, runId: run.id, lastLoadedAt: Date.now() }),
    setStats: (stats) => set({ stats }),
    setInventory: (inventory) => set({ inventory }),
    setEquipment: (equipment) => set({ equipment }),

    clear: () => set({
        runId: null,
        run: null,
        stats: null,
        inventory: null,
        equipment: null,
        lastLoadedAt: null,
    }),
}));
